import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router'
import superagent from 'superagent';
import LocalizedStrings from 'react-localization';

import {Modal, Form, FormControl, FormGroup, ControlLabel, ButtonToolbar, Button, Col} from 'react-bootstrap';
import styles from './LoginForm.css';
import { Login, Logged, LoggedUserJazyk } from '../login/Login';
import InfoMsg  from '../../api/InfoMsg';


let strings = new LocalizedStrings({
 en:{
   user:"USER LOGIN",
   newUser:"NEW USER",
   jmeno:"Name",
   email:"Email",
   heslo:"Password",
   heslo2:"Confirm password",
   login:"Login",
   register:"Register",
   jazyk:"Language",
   lostPass:"Lost password",
   complete:"User registration complete",
   complete2:"Vyčkejte na autorizaci Vašeho přístupu od administrátora.",
   zapomenuteHeslo: "Forgot your password?",
   noveHesloTitle: "SEND A NEW PASSWORD",
   sendButton: "Send password",
   closeButton: "Close",
},
 cs: {
   user:"PŘIHLÁŠENÍ UŽIVATELE",
   newUser:"NOVÝ UŽIVATEL",
   jmeno:"Jméno",
   email:"Email",
   heslo:"Heslo",
   heslo2:"Potvrzení hesla",
   login:"Přihlásit",
   register:"Registrovat",
   jazyk:"Jazyk",
   lostPass:"Zapomenuté heslo",
   complete:"Registrace uživatele byla dokončena.",
   complete2:"Vyčkejte na autorizaci Vašeho přístupu od administrátora.",
   zapomenuteHeslo: "Zapomněli jste heslo?",
   noveHesloTitle: "VYGENEROVAT NOVÉ HESLO",
   sendButton: "Odeslat heslo",
   closeButton: "Zavřít",
 }
});

export class LoginForm extends React.Component {

  constructor(props) {
    super(props);

    if (strings.getLanguage() != 'cs') {
      strings.setLanguage('en')
    }

    this.state = {
      username: '',
      password: '',
      errorMessage: '',
      errorMessageReg: '',
      jazyk: strings.getLanguage(),
      showModal: false,
      showModalNewPassword: false
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleLogSubmit = this.handleLogSubmit.bind(this);
    this.handleSubmitPassword = this.handleSubmitPassword.bind(this);
    this.handleRegSubmit = this.handleRegSubmit.bind(this);
    this.handleRegChange = this.handleRegChange.bind(this);
    this.handleChangeJazyk = this.handleChangeJazyk.bind(this);
    this.showModalNewPassword = this.showModalNewPassword.bind(this);
    this.closeModalNewPassword = this.closeModalNewPassword.bind(this);
  }

  handleUsernameChange(value) {
    this.setState({ username: value });
    this.setState({errorMessage: ''});
  }

  handlePasswordChange(value) {
    this.setState({ password: value });
    this.setState({errorMessage: ''});
  }

  handleRegChange(value) {
    this.setState({errorMessageReg: ''});
  }

  handleChangeJazyk(value) {
    var jazyk = ReactDOM.findDOMNode(this.refs.RegJazykInput).value;
    this.setState({errorMessageReg: '', jazyk: jazyk});
  }

  close() {
    //this.setState({ showModal: false });
    browserHistory.push('#/')
    window.location.reload();
  }

  showModalNewPassword() {
    //this.setState({ showModalNewPassword: true });
    $('#modalHeslo').modal('show');
  }

  closeModalNewPassword() {
    this.setState({ showModalNewPassword: false });
  }

  handleLogSubmit(event) {
    event.preventDefault();

    superagent.post('https://rezervace.copasedeje.cz/servis/_users.php').
      send("user="+ReactDOM.findDOMNode(this.refs.UserNameInput).value).
      send("heslo="+ReactDOM.findDOMNode(this.refs.PasswordInput).value).then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          window.sessionStorage.setItem("userID", myObject.user_id);
          window.sessionStorage.setItem("ID", myObject.id);
          window.sessionStorage.setItem("userName", myObject.popis);
          window.sessionStorage.setItem("userEmail", myObject.email);
          window.sessionStorage.setItem("userJazyk", myObject.jazyk);
          window.sessionStorage.setItem("opravneni", myObject.opravneni);
          window.sessionStorage.setItem("admin", myObject.admin);
          window.sessionStorage.setItem("lekce", myObject.lekce);
          this.props.setUser(myObject.id, myObject.popis);
        } else {
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessage: myObject.error});
          } else {
            this.setState({errorMessage: myObject.error_en});
          }
        }
      });

    return false;
  }

  handleSubmitPassword(event) {
    event.preventDefault();
    $('#modalHeslo').modal('hide');


    superagent.post('https://rezervace.copasedeje.cz/servis/_new_heslo.php').
      send("email="+ReactDOM.findDOMNode(this.refs.EmailPasswordInput).value).then(res => {
        var myObject = JSON.parse(res.text);
        if (LoggedUserJazyk() == 'cs') {
          this.setState({errorMessage: myObject.error});
        } else {
          this.setState({errorMessage: myObject.error_en});
        }
      });

      //this.setState({ showModalNewPassword: false });
    return false;
  }

  handleRegSubmit(event) {
    event.preventDefault();

    superagent.post('https://rezervace.copasedeje.cz/servis/_users_add.php').
      send("popis="+ReactDOM.findDOMNode(this.refs.RegUserNameInput).value).
      send("email="+ReactDOM.findDOMNode(this.refs.RegUserEmailInput).value).
      send("heslo="+ReactDOM.findDOMNode(this.refs.RegPasswordInput).value).
      send("heslo2="+ReactDOM.findDOMNode(this.refs.RegPassword2Input).value).
      send("jazyk="+ReactDOM.findDOMNode(this.refs.RegJazykInput).value).
      then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          window.sessionStorage.setItem("userID", myObject.id);
          window.sessionStorage.setItem("userName", myObject.popis);
          window.sessionStorage.setItem("userEmail", myObject.email);
          window.sessionStorage.setItem("userJazyk", myObject.jazyk);
          //this.setState({ showModal: true });
          $('#modalComplete').modal('show');

          //window.location.reload();
          //this.props.setUser(myObject.id,myObject.popis);
        } else {
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessageReg: myObject.error});
          } else {
            this.setState({errorMessageReg: myObject.error_en});
          }
        }
      });

    return false;
  }

  onLoginCompleted() {}

  onLoginFailed(err) {
    if (err.status && err.status === 403) {
      this.setState({
        errorMessage: 'Neplatné uživatelské jméno nebo heslo',
      });
    } else {
      this.setState({
        errorMessage: 'Nelze se přihlásit k serveru (chyba: ' + err.message + ').',
      });
    }
  }

  render() {
    /*if (Logged()) {
      strings.setLanguage(LoggedUserJazyk());
    } else {
      if (strings.getLanguage() != 'cs') {
        strings.setLanguage('en')
      }
    }*/
    strings.setLanguage(this.state.jazyk);

    return (
      <div className={styles.root + " row"}>
        <div className="col-md-6">
          <div className={styles.userPanel + " mb-3 col-sm-12 shadow"}>
            <h2 className={styles.uvodH2}><i className={"fa fa-user " + styles.panelHeaderFa}></i> {strings.user}</h2>

            <div id="uvod_platby" className={styles.panelHome + " card"}>

              <div className="card-body">
                <InfoMsg styleBS="danger" text={this.state.errorMessage}/>

                <form onSubmit={this.handleLogSubmit}>
                  <Col sm={12}>
                    <div className="form-group row">
                      <label htmlFor="UserNameInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.email}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="email" className={styles.input} placeholder={strings.email} ref="UserNameInput" id="UserNameInput" onChange={this.handleUsernameChange} required />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="PasswordInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.heslo}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="password" placeholder={strings.heslo} ref="PasswordInput" onChange={this.handlePasswordChange} required />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-9 offset-sm-3">
                        <ButtonToolbar>
                          <Button bsStyle="success" type="submit" >{strings.login}</Button>
                          <Button bsStyle="link" onClick={this.showModalNewPassword}>{strings.zapomenuteHeslo}</Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  </Col>
                </form>
              </div>

            </div>
            <div className={styles.clear}></div>
          </div>
        </div>

        <div className="col-md-6">
          <div className={styles.newUserPanel + " col-sm-12 shadow"}>
            <h2 className={styles.uvodH2}><i className={"fa fa-user " + styles.panelHeaderFa}></i> {strings.newUser}</h2>
            <div id="uvod_platby" className={styles.panelHome + " card"}>
              <div className="card-body">
                <InfoMsg styleBS="danger" text={this.state.errorMessageReg}/>

                <Form horizontal onSubmit={this.handleRegSubmit}>
                  <Col sm={12}>
                    <div className="form-group row">
                      <label htmlFor="RegJazykInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.jazyk}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl disabled componentClass="select" placeholder="select" ref="RegJazykInput" onChange={this.handleChangeJazyk} >
                          <option value="cs">česky</option>
                          <option value="en">english</option>
                        </FormControl>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="RegJazykInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.jmeno}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="text" placeholder={strings.jmeno} ref="RegUserNameInput" onChange={this.handleRegChange} required />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="RegJazykInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.email}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="email" placeholder={strings.email} ref="RegUserEmailInput" onChange={this.handleRegChange} required/>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="RegJazykInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.heslo}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="password" placeholder={strings.heslo} ref="RegPasswordInput" onChange={this.handleRegChange} required />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label htmlFor="RegJazykInput" className="col-sm-3 col-form-label text-sm-right text-left">
                        {strings.heslo2}:
                      </label>
                      <div className="col-sm-7">
                        <FormControl type="password" placeholder={strings.heslo2} ref="RegPassword2Input" onChange={this.handleRegChange} required />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-9 offset-sm-3">
                        <Button bsStyle="success" type="submit" >{strings.register}</Button>
                      </div>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          <div className={styles.clear}></div>

          <div className="static-modal">
            <div className="modal fade" id="modalComplete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="alert alert-success" role="alert">
                      {strings.complete}<br />{strings.complete2}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal">{strings.closeButton}</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal fade" id="modalHeslo" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <form onSubmit={this.handleSubmitPassword}>
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel"><i className={"fa fa-unlock-alt"}></i> {strings.noveHesloTitle}</h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <FormGroup>
                        <Col componentClass={ControlLabel} sm={3}>
                          {strings.email}:
                        </Col>
                        <Col sm={7}>
                          <FormControl type="email" placeholder={strings.email} ref="EmailPasswordInput" name="ContactEmailInput" onChange={this.handleRegChange} required/>
                        </Col>
                      </FormGroup>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
                      <button type="button" className="btn btn-success" type="submit" >{strings.sendButton}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/login/LoginForm.jsx